import bunny from '../../assets/bunny-mask.png'
import { burrowAppUrl } from '../../lib/env'
import '../../styles/reader.css'

// The foot of every writing (reader, preview, followers-only): where a reader
// who arrived from a shared link finds their way to Burrow itself. A full-width
// wine band (cream in dark mode), under the floating Taken pill and reading
// controls, edged in cross-stitches like the bunny it carries. Colours live
// in reader.css.

/** The app's host as readers see it ("app.burrow.world" in production). */
function appHost(): string {
  try {
    return new URL(burrowAppUrl).host
  } catch {
    return 'app.burrow.world'
  }
}

export function WritingFooter({ clearBottomBar = false }: { clearBottomBar?: boolean }) {
  // Room under the band's last line for the floating pills (Reading light
  // stacked over Taken on desks), so they never sit over the "Start your own"
  // button or the © line (Niki, 10/6).
  const foot = clearBottomBar ? 'pb-[calc(72px+1.75rem+env(safe-area-inset-bottom))]' : 'pb-24 sm:pb-36'
  return (
    <footer className="wr-footer relative z-[25] mt-20 font-sans">
      <div aria-hidden className="wr-footer-stitches absolute inset-x-0 top-3" />
      <div className={`mx-auto flex w-full max-w-[1040px] flex-col items-center gap-5 px-6 pt-11 text-center sm:flex-row sm:justify-between sm:text-left ${foot}`}>
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:gap-4">
          <a href={burrowAppUrl} aria-label="Burrow" className="wr-footer-bunny" style={{ maskImage: `url(${bunny})`, WebkitMaskImage: `url(${bunny})` }} />
          <div className="flex flex-col gap-0.5">
            <p className="m-0 font-display text-[22px]/[1.15] font-normal italic tracking-[-0.01em]">Made with Burrow</p>
            <p className="wr-footer-soft m-0 text-[13px]/[1.45]">A thinking space for your thoughts, and the writing that grows from them.</p>
          </div>
        </div>
        <div className="flex shrink-0 flex-col items-center gap-2 sm:items-end">
          <a href={burrowAppUrl} className="wr-footer-cta">
            Start your own at {appHost()}
            <span aria-hidden>→</span>
          </a>
          <p className="wr-footer-soft m-0 text-[10.5px] font-semibold tracking-[0.14em]">© {new Date().getFullYear()} BURROW</p>
        </div>
      </div>
    </footer>
  )
}
